import { DependentTask } from './dependentTask';

export class DependentTasks {
  context: string;
  tasks: DependentTask[];
}
